import userHasPermission from './userHasPermission';
export default userHasPermission;